// ToastNotification.js
import React, { useState, useEffect, useRef } from "react";
import Toast from "react-bootstrap/Toast";
import Fade from "react-bootstrap/Fade";

const ToastNotification = ({ show, onClose, message, toastTitle}) => {
    const toastRef = useRef(null);

    useEffect(() => {
        const handleTransitionEnd = () => {
            if (!show) {
                onClose();
            }
        };

        const toastElement = toastRef.current;

        // Ensure the element exists before adding the event listener
        if (toastElement) {
            toastElement.addEventListener("animationend", handleTransitionEnd);
        }

        return () => {
            // Clean up the event listener
            if (toastElement) {
                toastElement.removeEventListener("animationend", handleTransitionEnd);
            }
        };
    }, [show, onClose]);

    const colorMap = {
        'Error': '#ffcccc',
        'Information': '#9ACD32',
        'Warning': '#FFD700', // Add more mappings as needed
    };
  
    // Determine background color based on the toastTitle
    const headerStyle = {
        backgroundColor: colorMap[toastTitle] || '#FFFFFF' // Default color if no match
    };

    return (
        <Toast
            ref={toastRef}
            show={show}
            delay={3000}
            autohide
            style={{ position: 'absolute', top: 80, right: 20 }}
            className={`custom-toast ${!show ? 'slide-out' : ''}`}  // Add custom class here
            onClose={onClose} // Ensure onClose is called after autohide
        >
            <Toast.Header style={headerStyle}>
                <strong className="mr-auto">{toastTitle}</strong>
                <button
                    type="button"
                    className="ml-auto mb-1 close"
                    aria-label="Close"
                    onClick={onClose}
                    style={{
                        background: 'none',
                        border: 'none',
                        fontSize: '1.25rem',
                        color: '#000', // Color for the close icon
                        position: 'absolute',
                        right: 5,
                        top: 3,
                    }}
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </Toast.Header>
            <Toast.Body>{message}</Toast.Body>
        </Toast>
    );
};

export default ToastNotification;


// This is plain vanilla version.
const ToastNotification1 = ({ show, onClose, message, headerStyle }) => {
    return (
        <Toast
            onClose={onClose}
            show={show}
            delay={30000}
            autohide
            style={{ position: 'absolute', top: 80, right: 20 }}
        >
            <Toast.Header style={headerStyle}>
                <strong className="mr-auto">Error</strong>
                <button
                    type="button"
                    className="ml-auto mb-1 close"
                    aria-label="Close"
                    onClick={onClose}
                    style={{
                        background: 'none',
                        border: 'none',
                        fontSize: '1.25rem',
                        color: '#000', // Color for the close icon
                        position: 'absolute',
                        right: 10,
                        top: 10,
                    }}
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </Toast.Header>
            <Toast.Body>{message}</Toast.Body>
        </Toast>
    );
};